import logo from "../assets/images/logo/logo.png"


export const Config = {
    logo : logo,

}
